import type { SVGProps } from "react";

export function SpoonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 14V15C3 16.5913 3.63214 18.1174 4.75736 19.2426C5.88258 20.3679 7.4087 21 9 21C10.5913 21 12.1174 20.3679 13.2426 19.2426C14.3679 18.1174 15 16.5913 15 15V6C15 5.20435 15.3161 4.44129 15.8787 3.87868C16.4413 3.31607 17.2044 3 18 3C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6M3 14C3 14.821 4.481 15.526 6.604 15.834L7.104 15.898C7.7 15.964 8.337 16 9 16C9.63373 16.0008 10.267 15.9668 10.897 15.898L11.397 15.834C13.518 15.526 15 14.82 15 14C15 13.179 13.519 12.474 11.396 12.166L10.896 12.102C10.3 12.036 9.663 12 9 12C8.36627 11.9992 7.73298 12.0332 7.103 12.102L6.603 12.166C4.482 12.474 3 13.18 3 14Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
